// @ts-check

import { clsx } from "../../utils/strings.utils"

/**
 * @template {import("./createTaskReportsCommonColumns.factory.types").TaskReportCommonRow} TData
 * @param {import("./createTaskReportsCommonColumns.factory.types").CreateTaskReportsCommonColumnsParams<TData>} params
 */
export function createTaskReportsCommonColumns(params) {
  const { columnHelper, config, groupedDateCellTemplate } = params

  return {
    date: columnHelper.accessor((row) => row.date, {
      id: "date",
      header: "Fecha",
      cell: config.date.cellTemplate,
      footer: config.date.footerTemplate,
      enableColumnFilter: false,
      meta: {
        className: "date-column",
      },
    }),

    projectCode: columnHelper.accessor((row) => row.projectCode, {
      id: "projectCode",
      header: "Proyecto",
      cell: (
        /** @type {import("@tanstack/react-table").CellContext<TData, string>} */ ctx
      ) =>
        ctx.row.getIsGrouped() && groupedDateCellTemplate ?
          groupedDateCellTemplate(ctx)
        : config.projectCode.cellTemplate(ctx),
      footer: config.projectCode.footerTemplate,
      enableSorting: false,
      filterFn: config.projectCode.filterFn,
      meta: {
        filterElement: config.projectCode.filterElement,
        className: clsx("project-column", config.projectCode.classNames),
      },
      size: config.projectCode.size,
    }),

    module: columnHelper.accessor((row) => row.module, {
      id: "module",
      header: "Módulo",
      cell: config.module.cellTemplate,
      enableSorting: false,
      filterFn: config.module.filterFn,
      meta: {
        filterElement: config.module.filterElement,
        className: clsx("module-column", config.module.classNames),
      },
    }),

    categoryTitle: columnHelper.accessor((row) => row.categoryTitle, {
      id: "categoryTitle",
      header: "Categoría",
      cell: config.categoryTitle.cellTemplate,
      enableSorting: false,
      filterFn: config.categoryTitle.filterFn,
      meta: {
        filterElement: config.categoryTitle.filterElement,
        className: clsx("category-column", config.categoryTitle.classNames),
      },
    }),

    task: columnHelper.accessor((row) => row.task, {
      id: "task",
      header: "Tarea",
      enableSorting: false,
      cell: config.task.cellTemplate,
      meta: {
        filterElement: config.task.filterElement,
        className: "task-column",
      },
    }),

    sisuTime: columnHelper.accessor((row) => row.sisuTime, {
      id: "sisuTime",
      header: "Horas trabajadas",
      cell: config.sisuTime.cellTemplate,
      footer: config.sisuTime.footerTemplate,
      enableColumnFilter: false,
      meta: {
        className: "sisu-time-column",
      },
    }),

    billedTime: columnHelper.accessor((row) => row.billedTime, {
      id: "billedTime",
      header: "Horas facturadas",
      cell: config.billedTime.cellTemplate,
      footer: config.billedTime.footerTemplate,
      ...(config.billedTime.sortingFn && {
        sortingFn: config.billedTime.sortingFn,
      }),
      ...(config.billedTime.aggregationFn && {
        aggregationFn: config.billedTime.aggregationFn,
      }),
      enableColumnFilter: false,
      meta: { className: "billed-time-column" },
    }),

    timeDifference: columnHelper.accessor((row) => row.timeDifference, {
      id: "timeDifference",
      header: "Diferencia",
      cell: config.timeDifference.cellTemplate,
      footer: config.timeDifference.footerTemplate,
      ...(config.timeDifference.sortingFn && {
        sortingFn: config.timeDifference.sortingFn,
      }),
      ...(config.timeDifference.aggregationFn && {
        aggregationFn: config.timeDifference.aggregationFn,
      }),
      enableColumnFilter: false,
      meta: { className: "time-difference-column" },
    }),

    actions: columnHelper.display({
      id: "actions",
      cell: config.actions.cellTemplate,
      meta: { className: "actions-column" },
    }),
  }
}
